/** @flow */

import type { State } from "@store/reducers";
import type { RecentActivityItem } from "@modules/reporting/reducer/dashboard/types";

export const activityFeedDashboardList = (state: State) =>
  ((state.reporting || {}).dashboard || {} || {}).activityFeed;

export const recentActivityFeed = (state: State): RecentActivityItem[] =>
  ((state.reporting || {}).dashboard || {} || {}).recentActivity;
